import {
    LOAD_METRICS_FOR_AISLE_CALL_BEGIN,
    LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE,
    LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE,
    LOAD_STOW_PACKAGE_METRICS_FOR_AISLE,
    LOAD_METRICS_FOR_AISLE_CALL_FAILURE,
    LOAD_STOW_BIN_METRICS_FOR_AISLE,
    LOAD_STOW_BAG_METRICS_FOR_AISLE,
    LOAD_NODE_RESOURCE_DATA_FOR_AISLE, LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2,
    LOAD_STOW_CART_METRICS_FOR_AISLE
} from "../actions/AisleActions";
import {getNodeResourceDataMap} from "../Utility";

/**
 * Initial state of the system.
 */
const initialState = {
    loading: true,
    stowPackageMetricsMap: {},
    stowBinMetricsMap: {},
    stowBinMetricsMapForStowV2:{},
    stowCartMetricsMap: {},
    stowBagMetricsMap: {},
    inductPackageMetricsMap: {},
    stowAssociateMetricsMap: {},
    nodeResourceData : {},
    nodeResourceDataMap: new Map()
}

/**
 * Reducer function for Aisle View that changes state
 * based on the action triggered.
 */
export default function aisleReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_METRICS_FOR_AISLE_CALL_BEGIN:
            return {
                ...state,
                loading: true
            }
        case LOAD_STOW_PACKAGE_METRICS_FOR_AISLE:
            return {
                ...state,
                loading: false,
                stowPackageMetricsMap: action.stowPackageMetricsMap
            };
        case LOAD_STOW_BIN_METRICS_FOR_AISLE:
            return {
                ...state,
                loading: false,
                stowBinMetricsMap: action.stowBinMetricsMap
            };
        case LOAD_STOW_BAG_METRICS_FOR_AISLE:
            return {
                ...state,
                loading: false,
                stowBagMetricsMap: action.stowBagMetricsMap
            };
        case LOAD_STOW_CART_METRICS_FOR_AISLE:
            return {
                ...state,
                loading: false,
                stowCartMetricsMap: action.stowCartMetricsMap
            };
        case LOAD_INDUCT_PACKAGE_METRICS_FOR_AISLE:
            return {
                ...state,
                loading: false,
                inductPackageMetricsMap: action.inductPackageMetricsMap
            };
        case LOAD_STOW_ASSOCIATE_METRICS_FOR_AISLE:
            return {
                ...state,
                loading: false,
                stowAssociateMetricsMap: action.stowAssociateMetricsMap
            };
        case LOAD_METRICS_FOR_AISLE_CALL_FAILURE:
            return {
                ...state,
                loading: false
            };
        case LOAD_NODE_RESOURCE_DATA_FOR_AISLE :
            return {
                ...state,
                loading: false,
                nodeResourceData: action.nodeResourceData,
                nodeResourceDataMap: getNodeResourceDataMap(action.nodeResourceData)
            };
        case LOAD_STOW_BIN_METRICS_FOR_AISLE_FOR_STOW_V2 :
            return {
                ...state,
                loading: false,
                stowBinMetricsMapForStowV2 : action.stowBinMetricsMapForStowV2
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/AisleReducer.js